import { ContentService, ImageService, ObserverService } from '@DavisDigital/davisdigitalfrontend.module';

import { ContentModuleTypes } from '../interfaces';

class ImageDetailModalController {
	
	public image;

	private previouslyFocusedElement: HTMLElement | null = null;
	private focusableSelector = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
	
	// @ngInject
	constructor(
		public imageService		: ImageService,
		public contentService	: ContentService, 
		public observerService	: ObserverService,
		public ModalService,
		public $element,
		public $timeout			: ng.ITimeoutService
	){}
	
	public $onInit = () => {
		// Store the element that had focus before the modal opened
		this.previouslyFocusedElement = document.activeElement as HTMLElement;

		// Set initial focus to the close button after render
		this.$timeout(() => {
			const modalEl = this.$element[0].querySelector('.modal');
			if (modalEl) {
				modalEl.removeAttribute('aria-hidden');
				const closeBtn = modalEl.querySelector('.close') as HTMLElement;
				if (closeBtn) {
					closeBtn.focus();
				}
			}
		});
	}

	public handleKeydown = (event: KeyboardEvent) => {
		if (event.key === 'Escape' || event.keyCode === 27) {
			event.preventDefault();
			this.close();
		}

		// Trap focus within the modal
		if (event.key === 'Tab' || event.keyCode === 9) {
			this.trapFocus(event);
		}
	}

	private trapFocus = (event: KeyboardEvent) => {
		const modalEl = this.$element[0].querySelector('.modal');
		if (!modalEl) return;

		const focusableElements = modalEl.querySelectorAll(this.focusableSelector);
		if (focusableElements.length === 0) return;

		const firstFocusable = focusableElements[0] as HTMLElement;
		const lastFocusable = focusableElements[focusableElements.length - 1] as HTMLElement;

		if (event.shiftKey) {
			if (document.activeElement === firstFocusable) {
				event.preventDefault();
				lastFocusable.focus();
			}
		} else {
			if (document.activeElement === lastFocusable) {
				event.preventDefault();
				firstFocusable.focus();
			}
		}
	}
	
	public close = () =>{
		// Restore focus to the previously focused element
		const elementToFocus = this.previouslyFocusedElement;

		var modalToCloseIndex = 0;
		if(this.ModalService.openModals.length === 2){
			modalToCloseIndex = 1;
		}
		//This is a workaround ModalService technically does not support more than one modal
		this.ModalService.openModals[modalToCloseIndex].modal.element.modal('hide');
		this.ModalService.openModals.splice(modalToCloseIndex, 1);

		if (elementToFocus && elementToFocus.focus) {
			this.$timeout(() => {
				elementToFocus.focus();
			});
		}
	}
	
}

class ImageDetailModal {
	
	public restrict: string = 'E';
	public scope: boolean = true;
	
	public bindToController: any = {
		image: '='
	};

	public controller = ImageDetailModalController;
	public controllerAs = 'imageDetailModal';
	
	public templateUrl = __DAVIS_FRONTEND_BASE_PATH__ + '/davisdigital/directives/image-detail-modal.html';

	public static Factory() {
		return () => new this();
	}
}

export { ImageDetailModal };
